export enum DatePickerValidationError {
  EmptyDate = "EMPTY_DATE",
  InvalidDate = "INVALID_DATE",
}
